// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 25 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19.3175 3.05085L20.8863 2.26995L21.6672 0.701172L22.4481 2.26996L24.0169 3.05085L22.4481 3.83175L21.6672 5.40053L20.8863 3.83175L19.3175 3.05085Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.05475 3.71882L7.95764 1.51477L6.86054 3.71882L4.6565 4.81592L6.86054 5.91302L7.95764 8.11706L9.05475 5.91302L11.2588 4.81592L9.05475 3.71882Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.5544 13.3825L12.4057 8.23379L2.14819 18.4913L7.29695 23.64L17.5544 13.3825Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22.3861 8.55085L17.2373 3.4021L13.8201 6.81934L18.9688 11.9681L22.3861 8.55085Z"}}]};

const Filter2FilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'filter-2-filled',
    ref,
    icon: element,
  },
));

Filter2FilledIcon.displayName = 'Filter2FilledIcon';

export default Filter2FilledIcon;
